import React from 'react';
import {
    getAttachmentIconClass,
    getAttachmentIconColorClass,
    getAttachmentLabel,
} from './taskAttachmentUtils';

export const AttachmentContextTrigger = ({
    file,
    isOpen,
    onToggle,
    onDownload,
    buttonClassName,
    wrapperClassName,
}) => {
    return (
        <div className={wrapperClassName} data-attachment-menu-root>
            <button
                type="button"
                className={buttonClassName}
                onClick={() => onToggle(file?._id)}
                aria-expanded={isOpen}
            >
                <span className="d-inline-flex align-items-center gap-2">
                    <i className={`${getAttachmentIconClass(file)} ${getAttachmentIconColorClass(file)}`} aria-hidden="true" />
                    <span>{getAttachmentLabel(file)}</span>
                </span>
            </button>

            {isOpen && (
                <div
                    className="position-absolute border rounded bg-white shadow-sm p-2 px-3"
                    style={{ zIndex: 20, top: 'calc(100% + 4px)', left: 0, minWidth: '140px' }}
                >
                    <button type="button" className="dropdown-item rounded" onClick={() => onDownload(file)}>
                        <i className="bi bi-download me-2"></i>  Descargar
                    </button>
                </div>
            )}
        </div>
    );
};
